import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetType } from '../../../model/api/assets/asset-type';
import { GenericHttpService } from '../generic.http.service';
// import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class AssetTypeHttpService extends GenericHttpService<AssetType, number> {
    constructor(public http: HttpClient) {
        super(http, '', 'assettypes');
    }
}
